import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/ticketing/registrations')({
  staticData: { crumb: { parents: [{ label: 'Ticketing' }], label: 'Registrations' } },
})
